import { Action } from 'redux';

// ---------------------------------------------------------------------------
// Action type constants
// ---------------------------------------------------------------------------

// Initial GET on mount — resolves either to Success (valid token) or Invalid
// (any error). Success carries the customer's email + the marketplace name
// so the view can show "unsubscribe <email> from <business>'s emails".
export const EMAIL_UNSUBSCRIBE_FETCH_START = 'EMAIL_UNSUBSCRIBE_FETCH_START';
export const EMAIL_UNSUBSCRIBE_FETCH_SUCCESS = 'EMAIL_UNSUBSCRIBE_FETCH_SUCCESS';
export const EMAIL_UNSUBSCRIBE_FETCH_INVALID = 'EMAIL_UNSUBSCRIBE_FETCH_INVALID';

// POST triggered by the Confirm button. Success flips `justConfirmed` so the
// terminal card renders; Error rolls back to the pre-click state so the user
// can retry (the BE endpoint is idempotent).
export const EMAIL_UNSUBSCRIBE_CONFIRM_START = 'EMAIL_UNSUBSCRIBE_CONFIRM_START';
export const EMAIL_UNSUBSCRIBE_CONFIRM_SUCCESS = 'EMAIL_UNSUBSCRIBE_CONFIRM_SUCCESS';
export const EMAIL_UNSUBSCRIBE_CONFIRM_ERROR = 'EMAIL_UNSUBSCRIBE_CONFIRM_ERROR';

// ---------------------------------------------------------------------------
// Action interfaces
// ---------------------------------------------------------------------------

type EmailUnsubscribeFetchStartAction = Action<typeof EMAIL_UNSUBSCRIBE_FETCH_START>;

interface EmailUnsubscribeFetchSuccessAction extends Action<typeof EMAIL_UNSUBSCRIBE_FETCH_SUCCESS> {
    payload: {
        email: string;
        marketplaceName: string | null;
        alreadyOptedOut: boolean;
    };
}

type EmailUnsubscribeFetchInvalidAction = Action<typeof EMAIL_UNSUBSCRIBE_FETCH_INVALID>;

type EmailUnsubscribeConfirmStartAction = Action<typeof EMAIL_UNSUBSCRIBE_CONFIRM_START>;

type EmailUnsubscribeConfirmSuccessAction = Action<typeof EMAIL_UNSUBSCRIBE_CONFIRM_SUCCESS>;

type EmailUnsubscribeConfirmErrorAction = Action<typeof EMAIL_UNSUBSCRIBE_CONFIRM_ERROR>;

export type EmailUnsubscribeAction =
    | EmailUnsubscribeFetchStartAction
    | EmailUnsubscribeFetchSuccessAction
    | EmailUnsubscribeFetchInvalidAction
    | EmailUnsubscribeConfirmStartAction
    | EmailUnsubscribeConfirmSuccessAction
    | EmailUnsubscribeConfirmErrorAction;
